import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import LegalPage from "@/pages/LegalPage";
import { PRIVACY, AGREEMENT } from "@/lib/content";

function App() {
  useEffect(() => {
    if (new URLSearchParams(window.location.search).has("nolenis")) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/gizlilik-politikasi" element={<LegalPage data={PRIVACY} />} />
          <Route path="/kullanici-sozlesmesi" element={<LegalPage data={AGREEMENT} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
